import { Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { OdataSachbearbeiterRequest } from "../../api/models/odata-sachbearbeiter-request";
import { OdataSachbearbeiterResponse } from "../../api/models/odata-sachbearbeiter-response";
import { SachbearbeiterService } from "../../api/services/sachbearbeiter.service";

@Injectable({ providedIn: "root" })
export class SachbearbeiterCacheService {
  private static readonly TTL_MS = 10 * 60 * 1000;
  private cache = new Map<string, Observable<OdataSachbearbeiterResponse>>();
  private timestamps = new Map<string, number>();

  constructor(private sachbearbeiterService: SachbearbeiterService) {}

  getSachbearbeiter(params: OdataSachbearbeiterRequest): Observable<OdataSachbearbeiterResponse> {
    const key = params.sb_kuerzel;
    if (this.cache.has(key) && Date.now() - this.timestamps.get(key) > SachbearbeiterCacheService.TTL_MS) {
      this.cache.delete(key);
      this.timestamps.delete(key);
    }
    if (!this.cache.has(key)) {
      this.timestamps.set(key, Date.now());
      this.cache.set(
        key,
        this.sachbearbeiterService.sachbearbeiterOdataRetrieveCreate(params).pipe(shareReplay({ bufferSize: 1, refCount: false })),
      );
    }
    return this.cache.get(key);
  }
}
